import React, { useEffect, useState } from 'react';
import '../styles.css';
import 'flatpickr/dist/flatpickr.min.css';
import Sidebar from './Sidebar';
import StatCard from './StatCard';
import ActivityTable from './ActivityTable';
import { useNavigate } from "react-router-dom";
import { Session } from "../components/utils/session";
import { API_BASE_URL } from '../config';

export default function DashboardContent() {
  // Move these above all hooks to avoid temporal dead zone
  const role = Session.getRole();
  const token = Session.getToken();
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(false);
  const [mode, setMode] = useState('weekly');
  const [summary, setSummary] = useState({ productivityPercent: 0, neutralPercent: 0, });
  const [summaryError, setSummaryError] = useState(null);
  const [teams, setTeams] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  // Fetch teams (workspaces) for the dropdown
  useEffect(() => {
    if (!token) return;
    const controller = new AbortController();
    const fetchTeams = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/Workspace/Workspaces_List`, {
          headers: { Authorization: `Bearer ${token}` },
          signal: controller.signal,
        });
        if (!res.ok) throw new Error(`Status ${res.status}`);
        const data = await res.json();
        const list = (data || []).map((w) => ({
          id: String(w.WorkspaceID ?? w.workspaceID ?? w.workspaceId ?? w.id ?? ''),
          name: w.WorkspaceName ?? w.workspaceName ?? w.name ?? '',
        })).filter((w) => w.id);
        setTeams(list);
      } catch (err) {
        if (err.name === 'AbortError') return;
        setTeams([]);
      }
    };
    fetchTeams();
    return () => controller.abort();
  }, [token]);

  const navigate = useNavigate();


  useEffect(() => {
    const overlay = document.getElementById('sidebar-overlay');
    if (overlay) {
      overlay.style.display = showMobileSidebar ? 'block' : 'none';
    }
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      if (showMobileSidebar) sidebar.classList.add('show-mobile'); else sidebar.classList.remove('show-mobile');
      if (hideDesktop) sidebar.classList.add('hide-desktop'); else sidebar.classList.remove('hide-desktop');
    }
    const content = document.getElementById('content');
    if (content) {
      if (hideDesktop) content.classList.add('full-width'); else content.classList.remove('full-width');
    }
  }, [showMobileSidebar, hideDesktop]);

  const toggleSidebar = () => {
    if (window.innerWidth <= 991) {
      setShowMobileSidebar(s => !s);
    } else {
      setHideDesktop(s => !s);
    }
  };

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 991) {
        setShowMobileSidebar(false);
      }
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // useEffect(() => {
  //   if (!token) return;

  //   fetch(`${API_BASE_URL}/api/Workspace/Workspaces_List`, {
  //     headers: { Authorization: `Bearer ${token}` },
  //   })
  //     .then(async res => {
  //       if (!res.ok) throw new Error(`HTTP ${res.status}`);
  //       try {
  //         return await res.json();
  //       } catch {
  //         return [];
  //       }
  //     })
  //     .then(data => setWorkspaces(data || []))
  //     .catch(err => console.error('Workspace load error', err));
  // }, [token]);

useEffect(() => {
  const controller = new AbortController();

  const loadSummary = async () => {
    try {
      if (!token) return;

      let url = '';
      const params = new URLSearchParams();
      if (employeeName) params.append('employeeName', employeeName);

      if (mode === "daily") {
        url = `${API_BASE_URL}/api/UserActivityReport/daily`;
        if (selectedDate) params.append('date', selectedDate);
      } else {
        url = `${API_BASE_URL}/api/UserActivityReport/weekly`;
        // For weekly, use selectedDate as toDate, and fromDate as 6 days before
        let toDate = selectedDate || new Date().toISOString().slice(0, 10);
        let fromDate = new Date(new Date(toDate).getTime() - 6 * 24 * 60 * 60 * 1000)
          .toISOString().slice(0, 10);
        params.append('fromDate', fromDate);
        params.append('toDate', toDate);
      }
      const query = params.toString();
      if (query) url += `?${query}`;

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
      });

      if (!res.ok) throw new Error(`Status ${res.status}`);

      const rows = await res.json();

      let totalProductive = 0;
      let totalNeutral = 0;

      // Parse time in hh:mm:ss or -hh:mm:ss format
      const parseTime = (str) => {
        if (!str) return 0;
        // Remove negative sign for total calculation (or set to 0 if you want to ignore negatives)
        const cleanStr = str.replace(/^-/, '');
        const parts = cleanStr.split(":");
        if (parts.length !== 3) return 0;
        const hours = parseInt(parts[0], 10) || 0;
        const minutes = parseInt(parts[1], 10) || 0;
        const seconds = parseInt(parts[2], 10) || 0;
        // Convert to total seconds
        return hours * 3600 + minutes * 60 + seconds;
      };

      rows.forEach((r) => {
        totalProductive += parseTime(r.productive);
        totalNeutral += parseTime(r.neutral);
      });

      const total = totalProductive + totalNeutral;

      let productivityPercent = 0;
      let neutralPercent = 0;

      if (total > 0) {
        productivityPercent = (totalProductive / total) * 100;
        neutralPercent = (totalNeutral / total) * 100;
      }

      setSummary({
        productivityPercent: Math.round(productivityPercent),
        neutralPercent: Math.round(neutralPercent),
      });
    } catch (err) {
      if (err.name === "AbortError") return;
      console.error(err);
      setSummary({
        productivityPercent: 0,
        neutralPercent: 0,
      });
    }
  };

  loadSummary();
  return () => controller.abort();
}, [mode, selectedDate, token, employeeName]);




  const prod = Math.round(summary.productivityPercent || 0);
const neutral = Math.round(summary.neutralPercent || 0);

  console.log('updated:', prod, neutral);
  const statCards = [
    {
      icon: 'fas fa-chart-line',
      value: `${prod}%`,
      label: 'Members Productivity Time',
      color: 'icon-green',
    },
    {
      icon: 'fas fa-grip-lines-vertical',
      value: `${neutral}%`,
      label: 'Members Neutral Time',
      color: 'icon-blue',
    },
  ];

  return (
    <div>
      <div id="sidebar-overlay" className="sidebar-overlay" onClick={() => setShowMobileSidebar(false)} />
      <div id="sidebar">
        <Sidebar />
      </div>
      <div id="content">
        <div className="d-flex align-items-center mb-3">
          {/* <button
            type="button"
            className="btn btn-toggle me-3"
            onClick={toggleSidebar}
          >
            <i className="fas fa-bars" />
          </button> */}
          {/* <a href="/dashboard" className="text-muted text-decoration-none small">
            <i className="fas fa-chevron-left" /> Back
          </a> */}
        </div>
        <h2 className="mb-4">Productivity Reports</h2>
        <div className="row g-3 mb-4 filter-row align-items-end">
          <div className="col-12 col-md-6 col-xl-3">
            <div className="filter-box">
              <input
                type="radio"
                className="btn-check"
                id="daily"
                checked={mode === 'daily'}
                onChange={() => setMode('daily')}
              />
              <label className="btn btn-outline-custom px-3" htmlFor="daily">
                Daily
              </label>
              <input
                type="radio"
                className="btn-check"
                id="weekly"
                checked={mode === 'weekly'}
                onChange={() => setMode('weekly')}
              />
              <label className="btn btn-outline-custom px-3" htmlFor="weekly">
                Weekly
              </label>
            </div>
          </div>
          <div className="col-6 col-md-6 col-xl-3">
            <select
              className="form-select reportsInput"
              value={selectedWorkspace}
              onChange={(e) => setSelectedWorkspace(e.target.value)}
            >
              <option value="">All Teams</option>
              {teams.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-6 col-md-6 col-xl-3">
            <input
              type="text"
              className="form-control reportsInput"
              placeholder="Search employee"
              value={employeeName}
              onChange={(e) => setEmployeeName(e.target.value)}
            />
          </div>
          <div className="col-6 col-md-6 col-xl-3">
            <input
              type="date"
              className="form-control reportsInput"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </div>
        </div>
        <div className="row g-3 mb-4">
          {statCards.map(card => (
            <div className="col-12 col-lg-6 col-xl-6" key={card.label}>
              <StatCard {...card} />
            </div>
          ))}
        </div>
        <div className="main-card">
          <h5 className="fw-bold mb-3">
            {mode === 'daily' ? 'Daily Activity' : 'Weekly Activity'}
          </h5>
          <ActivityTable
            mode={mode}
            WorkspaceID={selectedWorkspace}
            employeeName={employeeName}
            selectedDate={selectedDate}
          />
        </div>
      </div>
    </div>
  );
}
